<script setup lang="ts">
/** 공용 — Person Transacting on Behalf. (3개 폼 동일) */
import CddDocVarField from './CddDocVarField.vue';

interface Row { k?: string; l?: string; cn?: string; combo?: boolean }
const rows: Row[] = [
  { k: 'pt_full_name', l: 'Full Name', cn: '全名' },
  { k: 'pt_ic_passport_no', l: 'NRIC/Passport No.', cn: '身份证/护照编号' },
  { k: 'pt_dob', l: 'Date of Birth', cn: '出生日期' },
  { k: 'pt_residential_address', l: 'Residential Address', cn: '住宅地址' },
  { k: 'pt_town', l: 'Town', cn: '城镇' },
  { k: 'pt_state', l: 'State', cn: '州际' },
  { combo: true }, // Postcode + Country
  { k: 'pt_nationality', l: 'Nationality', cn: '国籍' },
  { k: 'pt_occupation', l: 'Occupation', cn: '职业类型' },
  { k: 'pt_employer_name', l: 'Name of Employer/Nature of Business', cn: '雇主名称/业务性质' },
  { k: 'pt_contact_no', l: 'Contact Number (home/office/mobile)', cn: '联系电话（家庭/办公室/手机）' },
];
</script>

<template>
  <table class="cdd-tbl" style="margin-top:14px">
    <tbody>
      <tr><td class="cdd-sec" colspan="2">PERSON TRANSACTING ON BEHALF OF INDIVIDUAL / LEGAL PERSON / LEGAL ARRANGEMENT <span class="cdd-cn">代表个人/法人/法律安排进行交易的人</span></td></tr>
      <template v-for="(r, i) in rows" :key="i">
        <tr v-if="r.combo">
          <td class="cdd-lcell">Postcode <span class="cdd-cn">邮政编码</span> &nbsp; <CddDocVarField field-key="pt_postcode" /></td>
          <td>Country <span class="cdd-cn">乡村/国家</span> &nbsp; <CddDocVarField field-key="pt_country" /></td>
        </tr>
        <tr v-else>
          <td class="cdd-lcell">{{ r.l }} <span class="cdd-cn">{{ r.cn }}</span></td>
          <td><CddDocVarField :field-key="r.k!" /></td>
        </tr>
      </template>
    </tbody>
  </table>
</template>
